import MobileHeaderNavigation from './MobileHeaderNavigation.vue';

export default MobileHeaderNavigation;
